<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1366 458"
    class="icon-podbean-logo"
    xml:space="preserve"
    fill="currentColor"
  >
    <path
      d="M378.2,286.5c-17.6-17.6-41.1-27.3-66-27.3c-51.4,0-93.3,41.9-93.3,93.3s41.9,93.3,93.3,93.3
	c24.9,0,48.3-9.7,66-27.3c17.6-17.6,27.3-41.1,27.3-66C405.5,327.6,395.8,304.1,378.2,286.5z M312.2,401.5c-27,0-49-22-49-49
	c0-27,22-49,49-49c27,0,49,22,49,49C361.2,379.5,339.2,401.5,312.2,401.5z"
    />
    <path
      d="M192.4,231.4c-5.2,0-10.5-1.4-15.2-4.4c-13-8.2-16.7-25.1-8.3-37.8c15.3-23,36.4-42.2,61-55.5
	c25.4-13.8,54.3-21,83.5-21c46,0,89.2,17.4,121.8,49.1c8.6,8.4,16.3,17.6,22.9,27.5c8.4,12.7,4.7,29.6-8.3,37.8
	c-13,8.2-30.4,4.6-38.8-8c-4.5-6.7-9.7-12.9-15.5-18.6c-21.9-21.3-51.1-33.1-82.1-33.1c-39.4,0-75.9,19.3-97.5,51.7
	C210.6,227,201.6,231.4,192.4,231.4z"
    />
    <path
      d="M526.5,182.3c-9.2,0-18.2-4.4-23.6-12.4c-8.4-12.6-18.2-24.3-29.2-35c-41.4-40.1-96.4-62.2-155-62.2
	c-74.5,0-143.3,36.3-184,97.2c-5.4,8-14.4,12.4-23.6,12.4c-5.2,0-10.5-1.4-15.2-4.4c-13-8.2-16.7-25-8.3-37.6
	c24.5-36.7,58.3-67.3,97.6-88.5c40.6-21.9,86.8-33.5,133.5-33.5c73.5,0,142.7,27.8,194.7,78.2c13.8,13.3,26.1,28.1,36.6,43.8
	c8.4,12.6,4.7,29.5-8.3,37.6C537.1,180.9,531.8,182.3,526.5,182.3z"
    />
    <g>
      <path
        d="M12,443V211h75.4c28.5,0,47.1,1.2,55.9,3.5c13.3,3.5,24.5,11.2,33.5,22.8c9,11.7,13.5,26.8,13.5,45.2
		c0,14.3-2.6,26.4-7.8,36.1c-5.2,9.8-11.8,17.4-19.8,22.9c-8.1,5.5-16.2,9.2-24.3,11c-11.2,2.2-27.5,3.3-48.8,3.3H59v87H12z M59,250
		v66h25.7c18.5,0,30.8-1.2,37-3.7c6.2-2.4,11.1-6.2,14.6-11.4c3.5-5.2,5.3-11.2,5.3-18.2c0-8.4-2.5-15.4-7.4-20.9
		c-4.9-5.5-11.2-9-18.7-10.3c-5.6-1-16.9-1.6-33.9-1.6H59z"
      />
      <path
        d="M608,443h-42v-24.7c-6.8,9.6-14.9,16.7-24.3,21.5c-9.4,4.7-18.8,7.1-28.2,7.1c-19.3,0-35.9-7.8-49.7-23.4
		c-13.8-15.6-20.7-37.3-20.7-65.2c0-28.5,6.7-50.2,20.1-65.1c13.4-14.9,30.4-22.4,50.9-22.4c18.7,0,48.8,23.5,48.8,23.5V211h45V443z
		M488.7,355.3c0,18,2.4,31,7.3,39c7.2,11.7,17.3,17.5,30.1,17.5c10.3,0,19.1-4.4,26.2-13.1c7.2-8.7,10.7-21.7,10.7-39
		c0-19.3-3.5-33.3-10.4-41.8c-6.9-8.6-15.9-12.8-26.8-12.8c-10.6,0-19.5,4.2-26.6,12.6C492.2,326,488.7,338.6,488.7,355.3z"
      />
      <path
        d="M640,211h92.8c18.4,0,32.1,0.8,41.1,2.3c9,1.5,17,4.8,24.2,9.6c7.1,4.9,13.1,11.3,17.8,19.4
		c4.7,8.1,7.1,17.2,7.1,27.2c0,10.8-2.9,20.7-8.7,29.7c-5.8,9.1-13.7,15.9-23.8,20.4c14.1,4.1,25,11.2,32.6,21.1
		c7.6,9.9,11.4,21.6,11.4,35c0,10.5-2.5,20.7-7.4,30.7c-4.9,10-11.6,18-20.1,24c-8.5,6-19,9.6-31.5,10.9c-7.8,0.9-26.6,1.4-56.3,1.5
		H640V211z M687,249v54h30.9c18.4,0,29.8-0.3,34.2-0.9c8.1-0.9,14.5-3.7,19.1-8.3c4.6-4.7,6.9-10.7,6.9-18.1c0-7.3-2-13.1-6-17.7
		c-4-4.5-9.9-7.2-17.8-8.1c-4.6-0.6-18-0.9-40.2-0.9H687z M687,342v62h43.5c16.8,0,27.4-0.4,32-1.3c6.9-1.3,12.6-4.4,17-9.3
		c4.4-4.9,6.6-11.4,6.6-19.6c0-7.1-1.7-13-5.1-17.8c-3.4-4.8-8.3-8.3-14.7-10.6c-6.4-2.3-20.3-3.4-41.6-3.4H687z"
      />
      <path
        d="M960.7,389.7l44.3,7.5c-5.8,16.2-14.8,28.6-27,37.1c-12.2,8.5-27.7,12.7-46.3,12.7c-29.2,0-50.8-9.5-64.9-28.6
		c-11.1-15.3-16.6-34.7-16.6-58c0-27.9,7.3-49.8,21.8-65.6c14.5-15.9,32.9-23.8,55.2-23.8c25.1,0,44.8,8.3,59.1,24.9
		c14.3,16.6,21.5,41.9,21.5,76h-112c0.3,13.1,3.9,23.4,10.7,30.8c6.9,7.4,15.4,11.1,25.6,11.1c7.1,0,13-1.9,17.7-5.8
		C954.6,404.2,958.2,398.1,960.7,389.7z M963.2,345c-0.3-13-3.6-22.8-10-29.5c-6.3-6.7-14.1-10.1-23.2-10.1
		c-9.6,0-17.6,3.5-23.9,10.6c-6.3,7.1-9.5,16.7-9.5,29H963.2z"
      />
      <path
        d="M1064.9,326.1l-40.9-7.3c4.6-16.4,12.5-28.5,23.7-36.3c11.2-7.8,27.8-11.7,49.8-11.7c20.1,0,35.1,2.4,44.9,7.1
		c9.8,4.7,16.7,10.7,20.7,17.9c3.9,7.2,5.9,20.5,5.9,39.8l-0.4,52c0,14.8,0.7,25.7,2.2,32.8c1.5,7.1,4.2,14.6,8,22.6h-44.4
		c-1.2-2.9-2.6-7.3-4.2-13.1c-0.7-2.7-1.3-4.4-1.6-5.3c-7.7,7.4-16,12.9-24.7,16.6c-8.7,3.7-18.1,5.5-28,5.5
		c-17.4,0-31.2-4.7-41.3-14.1c-10.1-9.4-15.2-21.3-15.2-35.7c0-9.4,2.3-17.9,6.9-25.3c4.6-7.4,11.1-13.2,19.3-17.2
		c8.3-4,20.1-7.4,35.6-10.4c21-3.8,35.6-7.4,43.8-10.8v-4.4c0-8.6-2.1-14.7-6.4-18.4c-4.2-3.7-12.3-5.5-24.2-5.5
		c-8,0-14.3,1.6-18.8,4.8C1071.2,312.8,1067.6,318.3,1064.9,326.1z M1125,362.3c-5.8,1.9-14.8,4.2-27.1,6.9
		c-12.3,2.7-20.4,5.2-24.2,7.7c-5.9,4.1-8.9,9.4-8.9,15.7c0,6.2,2.3,11.5,7,16c4.6,4.5,10.6,6.8,17.8,6.8c8.1,0,15.8-2.6,23-7.7
		c5.3-4.1,8.9-9.1,10.6-14.8c1.2-3.8,1.8-11.1,1.8-21.7V362.3z"
      />
      <path
        d="M1355,443h-45v-85.9c0-18.1-1-29.9-2.9-35.3c-1.9-5.4-5-9.6-9.2-12.5c-4.3-2.9-9.4-4.4-15.4-4.4
		c-7.6,0-14.5,2.1-20.6,6.4c-6.1,4.3-10.3,9.9-12.5,16.8c-2.3,6.9-3.4,19.8-3.4,38.7V443h-44V275h41v24.5
		c14.6-19,33.1-28.5,55.3-28.5c9.9,0,18.9,1.8,27,5.3c8.1,3.5,14.3,8.1,18.5,13.6c4.2,5.5,7.1,11.8,8.7,18.7
		c1.6,6.9,2.4,16.9,2.4,29.8V443z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconPodbeanLogo"
};
</script>

<style lang="scss" scoped>
</style>
